export enum allowedFinancialInstruments {
  API = 'api',
  PAYMENT_LINKS = 'payment_links',
  ACCOUNTS_PAYABLE = 'accounts_payable',
}
